﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPTokenView = void 0;
const com = require("../tmpls");
const App_1 = require("../../App");
class UPTokenView extends com.CmpBlockUpToken {
    constructor(contract, burnable) {
        super();
        this._contract = contract;
        this._burnable = burnable;
        this.ctrls.btnBurn.onclick = () => this.tryBurn();
        this.ctrls.btnRefresh.onclick = () => this.refresh();
        let inputPhonePrevValue = '';
        let iBurnInput = this.ctrls.iBurnValue.el;
        iBurnInput.addEventListener("input", (e) => {
            if (iBurnInput.value && !new RegExp(/^\d$|^\d+(\.\d+)?$|^\d+(\.)?$/).test(iBurnInput.value)) {
                iBurnInput.value = inputPhonePrevValue;
                return;
            }
            inputPhonePrevValue = iBurnInput.value;
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            this.ctrls.btnRefresh.disable();
            const initSupply = 51869006448.8;
            const total = yield this._contract.totalSupply();
            this.ctrls.btnRefresh.enable();
            const burned = (initSupply - parseFloat(total)) + "";
            this.ctrls.lTotal.html = `Remaining Supply: <span>${App_1.App.Inst.chain.ethToFormat(total + "")}</span>`;
            this.ctrls.lBurned.html = `Burned: <span>${App_1.App.Inst.chain.ethToFormat(burned + "")}</span>`;
        });
    }
    tryBurn() {
        return __awaiter(this, void 0, void 0, function* () {
            yield App_1.App.Inst.chain.getAccountAsync();
            const value = parseFloat(this.ctrls.iBurnValue.value);
            if (!value)
                return;
            this._burnable.burn(value + "");
        });
    }
}
exports.UPTokenView = UPTokenView;
//# sourceMappingURL=UPTokenView.js.map